import { useQuery } from 'react-query';
import { fetcher } from '../utils/api';
import { ApiRoutes } from '../constants/routes';
import { useAuthProvider } from '../utils/auth';

// Whether the signed-in user may review a piece of content (people credited
// on a release can't review it). Shared by the reviews section and the
// three-dot menus - same query key, so they reuse one request.
//
// Returns { isAuthed, canReview, reason }. canReview is optimistic (true)
// until the check has loaded, and always false when logged out.
export const useCanReview = (contentType, contentId, { enabled = true } = {}) => {
  const { user, isAuthed } = useAuthProvider();

  const { data } = useQuery({
    queryKey: ['can-review', contentType, contentId, user?.uuid],
    queryFn: () => fetcher(`${ApiRoutes.CanReviewContent}?content_type=${contentType}&object_id=${contentId}`),
    enabled: enabled && !!user && !!contentType && !!contentId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isAuthed: !!user && isAuthed,
    canReview: !!user && data?.can_review !== false,
    reason: data?.reason || null,
  };
};
